// extracted by mini-css-extract-plugin
export default {"text":"copyButton_text__LXBSh","tip":"copyButton_tip__6ydqu","btn":"copyButton_btn__nkKYh"};